import { getFileItems } from '../../../../../api'
import { useUk } from '../../../../../hooks'
import {
  ATTACH_ACTION_SELECT_ACTION_FILE,
  ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
} from '../../../../AttachActionSelect'
import { FileAttachItemsModal } from '../../../../File'
import { getNewsboardPostFormAttachActions } from '../../NewsboardPostForm.utils'

export function useNewsboardPostFormAttach({
  selectedStorageFiles,
  onAttachFilesFromStorage,
  onCloseModal,
  onSetModal,
}) {
  const { directory_id: directory } = useUk()

  function handleAttachAction(action) {
    switch (action.value) {
      case ATTACH_ACTION_SELECT_ACTION_FILE:
        // handling action in `AttachActionSelect`
        break
      case ATTACH_ACTION_SELECT_FILE_FROM_STORAGE:
        onSetModal(
          <FileAttachItemsModal
            ButtonRemove={false}
            directoryId={directory}
            getData={getFileItems}
            initialValues={selectedStorageFiles}
            onClose={onCloseModal}
            onSubmit={onAttachFilesFromStorage}
          />
        )
        break
      default:
        return null
    }
  }

  const attachActionOptions = getNewsboardPostFormAttachActions()

  return { attachActionOptions, handleAttachAction }
}
